import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_FAULT_MANAGEMENT } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDFaultManagementState extends EntityState<IID_FAULT_MANAGEMENT, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_FAULT_MANAGEMENT , realtimeEntity: 'IID_FaultManagement'})
@InterfaceDataStore(InterfaceName.FAULT_MANAGEMENT)
export class IIDFaultManagementStore extends EntityStore<IIDFaultManagementState> {

  constructor() {
    super([]);
  }

}
